import { render, staticRenderFns } from "./DashboardHelpFirstTime.vue?vue&type=template&id=50c80674&scoped=true&lang=html&"
import script from "./DashboardHelpFirstTime.vue?vue&type=script&lang=js&"
export * from "./DashboardHelpFirstTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c80674",
  null
  
)

export default component.exports